import { Spinner, BcStateContext, BcStateForm } from '@bayclubs/state';

import { BlockedSlotEventDetailsModel, GroupClassEventDetailsModel, CourtBookingEventDetailsModel } from '@bayclubs/court-booking-employee-api';

export const COURT_EVENT_DETAILS_FEATURE_KEY = 'courtEventDetails';

export interface CourtEventDetailsStateModel {
    blockedSlotDetails: BcStateContext<BlockedSlotEventDetailsModel>;
    courtClassDetails: BcStateContext<GroupClassEventDetailsModel>;
    courtBookingDetails: BcStateContext<CourtBookingEventDetailsModel>;
}